/*
 * File: mutation-type.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-14 8:02:02 pm
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */

// 使用常量替代 mutation 事件类型在各种 Flux 实现中是很常见的模式。
// 这样可以使 linter 之类的工具发挥作用，
// 同时把这些常量放在单独的文件中
// 可以让你的代码合作者对整个 app 包含的 mutation 一目了然：

/** user.js */
// 权限菜单
export const USER_SET_AUTO_LIST = 'USER_SET_AUTO_LIST';
// 当前权限身份
export const USER_SET_NEW_AUTO_TYPE = 'USER_SET_NEW_AUTO_TYPE';
// 当前登录用户信息
export const USER_SER_CURRENT_USER = 'USER_SER_CURRENT_USER';
// 是否已经设置过权限菜单
export const AUTH_IS_SET_MENU = 'AUTH_IS_SET_MENU';
// 设置 brand 品牌
export const SET_BRAND = 'SET_BRAND';
// 设置 品牌列表
export const SET_BRAND_LIST = 'SET_BRAND_LIST';
// 是否已经请求过权限菜单
export const SET_FLAG_GET_AUTH_LIST = 'SET_FLAG_GET_AUTH_LIST';
// 顶部菜单权限
export const SET_TOP_MENU_LIST = 'SET_TOP_MENU_LIST';
// 独立应用
export const SET_INDIE_APPS_LIST = 'SET_INDIE_APPS_LIST';
// 积分商城登录信息
export const SET_INTEGRAL_MALL_INFO = 'SET_INTEGRAL_MALL_INFO';

// 设置用户美居运营展示渠道列表（美居APP，布谷APP，熊小美社区，美的冰箱竖屏，COLMO冰箱竖屏，省电费APP）
export const USER_SET_SOURCE_SYSTEM_LIST = 'USER_SET_SOURCE_SYSTEM_LIST';
// 页面管理通用数据
export const SET_POST_DATA = 'SET_POST_DATA';
// 页面管理 组件列表
export const SET_ASSEMBLYLIST = 'SET_ASSEMBLYLIST';
// 页面管理 组件列表
export const SET_POST_DATA_ID = 'SET_POST_DATA_ID';
// 页面管理 组件列表
export const SET_POST_DATA_NAME = 'SET_POST_DATA_NAME';
// 页面管理 组件列表
export const SET_AD_INFO = 'SET_AD_INFO';
// 页面管理 组件列表
export const SET_POST_DATA_POS = 'SET_POST_DATA_POS';
// 页面管理 组件列表
export const SET_POST_DATA_CHANNEL = 'SET_POST_DATA_CHANNEL';
// 页面管理 组件列表
export const SET_POST_DATA_PRODUCT_ARR = 'SET_POST_DATA_PRODUCT_ARR';
// 页面管理 组件列表
export const SET_POST_DATA_ASSOCIATE = 'SET_POST_DATA_ASSOCIATE';
// 页面管理 组件列表
export const SET_POST_DATA_CATEGORY = 'SET_POST_DATA_CATEGORY';
// 页面管理 组件列表
export const SET_SELECTEDINDEX = 'SET_SELECTEDINDEX';
// 页面管理 组件列表
export const SET_SELECTELEMENTINDEX = 'SET_SELECTELEMENTINDEX';
// 页面管理 组件列表
export const SET_SELECTED_TAB = 'SET_SELECTED_TAB';
// 页面管理 组件列表
export const SET_HOT_SPACE_INDEX = 'SET_HOT_SPACE_INDEX';
// 页面管理 页面类型
export const SET_PAGE_TYPE = 'SET_PAGE_TYPE';
// 页面管理 组件列表
export const SET_ISVALIDCOMS = 'SET_ISVALIDCOMS';
// 页面管理 组件列表
export const SET_ISNEEDPRODUCTMODEL = 'SET_ISNEEDPRODUCTMODEL';
// 页面管理 组件列表
export const SET_ISNEEDPRODUCTCATEGORY = 'SET_ISNEEDPRODUCTCATEGORY';
// 页面管理 组件列表
export const SET_ELEMENT = 'SET_ELEMENT';
// 页面管理 组件列表
export const SET_HOT_SPACE = 'SET_HOT_SPACE';
// 页面管理 组件列表
export const SET_ELEMENT_CONTENT = 'SET_ELEMENT_CONTENT';
// 页面管理 组件列表
export const SET_TAB_COMPONENT_CONTENT = 'SET_TAB_COMPONENT_CONTENT';
// 页面管理 清除
export const CLEAR_PAGE_STORE = 'CLEAR_PAGE_STORE';
// 页面管理 清除
export const SET_PAGE_STATUS = 'SET_PAGE_STATUS';
// 页面管理 是否tab页
export const SET_IS_TAB_PAGE = 'SET_IS_TAB_PAGE';
// 页面管理 子组件
export const SET_SUB_COMPONENT = 'SET_SUB_COMPONENT';
// 0未发布(默认) 1发布中   0非定时发布(默认) 1定时发布
export const SET_PUB_STATUS = 'SET_PUB_STATUS';

/** common.js */
// 列表页搜索条件
export const LIST_PAGE_SEARCH_PARAMS = 'LIST_PAGE_SEARCH_PARAMS';
